import React from 'react'
import contact from './contact.module.css'
import Contactpage from './Contactpage'
import Footer from '../Footer/Footer'
import Nav from '../Nav/Nav'
import Contactpage2 from './Contactpage2'
import Contactpaage3 from './Contactpaage3'
import ContactForm from './ContactForm'
import useStore from '../../../Store'
const Contact = () => {
    const direction = useStore((state) => state.direction);
    return (
        <div style={{ direction }}>
            <Nav />
            <div className={contact.Contact_container}>
                <Contactpage />
                <Contactpage2 />
                <Contactpaage3 />
                <ContactForm />
            </div>
            <Footer />
        </div>
    )
}

export default Contact